import request from "../utils/request";

export const getTodos = '/todo/'

export function readMessage(type: number, id: number) {
    return request.request({
        url: '/todo/read',
        method: 'post',
        data: {type, id}
    })
}

export function getNotReadTodosCount() {
    return request.request({
        url: '/todo/count',
        method: 'get'
    })
}